import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { showError, showSuccess } from '../../../../utils/Notifications';
import projectSupportersService from '../service/project-supporters.service';
import { ProjectOrganizationResponseDto } from '../dto/response/project-organization-response.dto';
import { ProjectOrganizationSaveRequestDto } from '../dto/request/project-organization-save-request.dto';
// import { ProjectOrganizationUpdateRequestDto } from '../dto/request/project-organization-update-request.dto';
import { BuyerResponseDto } from '../../../buyerAPI/buyer/dto/response/buyer-response.dto';
import { ProjectOrganizationRelationType } from '../project-organization-relation-type';

const initialState = {
  status: 'idle',
  projectSupporters: [] as ProjectOrganizationResponseDto[] | null,
  projectSupporter: {} as ProjectOrganizationResponseDto | null,
  projectBuyers: [] as BuyerResponseDto[] | null,
  error: null as string | null,
};

// export const fetchProjectSupportersByLandscapeProjectId = createAsyncThunk(
//   'projectSupporters/fetchProjectSupportersByLandscapeProjectId',
//   async (id: string) => {
//     return await projectSupportersService.fetchProjectSupportersByLandscapeProjectId(
//       id
//     );
//   }
// );

// export const fetchProjectSupportersBySupporterId = createAsyncThunk(
//   'projectSupporters/fetchProjectSupportersBySupporterId',
//   async (id: string) => {
//     return await projectSupportersService.fetchProjectSupportersBySupporterId(
//       id
//     );
//   }
// );

export const fetchProjectSupportersByOrganizationId = createAsyncThunk(
  'projectSupporters/fetchProjectSupportersByOrganizationId',
  async (id: string) => {
    return await projectSupportersService.fetchProjectSupportersByOrganizationId(
      id
    );
  }
);

export const fetchProjectSupportersByIds = createAsyncThunk(
  'projectSupporters/fetchProjectSupportersByIds',
  async (params: {
    id: string;
    relationShipType: ProjectOrganizationRelationType;
  }) => {
    return await projectSupportersService.fetchProjectSupportersByProjectId(
      params.id,
      params.relationShipType
    );
  }
);

export const saveProjectSupporters = createAsyncThunk(
  'projectSupporters/saveProjectSupporters',
  async (saveRequest: ProjectOrganizationSaveRequestDto) => {
    return await projectSupportersService.saveProjectSupporters(saveRequest);
  }
);

// export const updateProjectSupporters = createAsyncThunk(
//   'projectSupporter/updateProjectSupporters',
//   async (updateRequest: ProjectOrganizationUpdateRequestDto) => {
//     return await projectSupportersService.updateProjectSupporters(
//       updateRequest
//     );
//   }
// );

export const deleteProjectSupporters = createAsyncThunk(
  'projectSupporter/deleteProjectSupporters',
  async (existingId: string, { rejectWithValue }) => {
    try {
      await projectSupportersService.deleteProjectSupporters(existingId);
    } catch (e) {
      return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
    }
  }
);

const projectSupporterSlice = createSlice({
  name: 'projectSupporterSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // .addCase(fetchProjectSupportersByLandscapeProjectId.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(
      //   fetchProjectSupportersByLandscapeProjectId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.projectSupporters = action.payload;
      //   }
      // )
      // .addCase(
      //   fetchProjectSupportersByLandscapeProjectId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )

      // .addCase(fetchProjectSupportersBySupporterId.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(
      //   fetchProjectSupportersBySupporterId.fulfilled,
      //   (state, action) => {
      //     state.status = 'succeeded';
      //     state.projectSupporters = action.payload;
      //   }
      // )
      // .addCase(
      //   fetchProjectSupportersBySupporterId.rejected,
      //   (state, action) => {
      //     state.status = 'failed';
      //     state.error = action.error?.message ?? null;
      //   }
      // )

      .addCase(fetchProjectSupportersByOrganizationId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(
        fetchProjectSupportersByOrganizationId.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.projectSupporters = action.payload;
        }
      )
      .addCase(
        fetchProjectSupportersByOrganizationId.rejected,
        (state, action) => {
          state.status = 'failed';
          state.error = action.error?.message ?? null;
        }
      )

      .addCase(fetchProjectSupportersByIds.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectSupportersByIds.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectBuyers = action.payload;
      })
      .addCase(fetchProjectSupportersByIds.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      .addCase(saveProjectSupporters.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveProjectSupporters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectSupporters?.push(action.payload);
        showSuccess('Project Supporter added successfully.');
      })
      .addCase(saveProjectSupporters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })

      // .addCase(updateProjectSupporters.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(updateProjectSupporters.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   showSuccess('Project Supporter saved successfully.');
      //   if (state.projectSupporters) {
      //     const projectSupporterIndex = state.projectSupporters.findIndex(
      //       (projectSupporter) => projectSupporter.id === action.payload.id
      //     );
      //     if (projectSupporterIndex !== -1) {
      //       state.projectSupporters[projectSupporterIndex] = action.payload;
      //     }
      //   }
      // })
      // .addCase(updateProjectSupporters.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })

      .addCase(deleteProjectSupporters.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProjectSupporters.fulfilled, (state) => {
        state.status = 'succeeded';
        showSuccess('Project Supporter deleted successfully.');
      })
      .addCase(deleteProjectSupporters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
        showError(
          `Deleting projectSupporter failed. ${action.payload as string}`
        );
      });
  },
});

export default projectSupporterSlice.reducer;
